import React, { useState } from 'react'
import _ from 'lodash'
import { compose } from 'recompose'
import { Query, withApollo } from 'react-apollo'
import { Select } from 'antd'
// import { Query } from 'react-apollo'
import gql from 'graphql-tag'

const { Option } = Select

const BARANGAY_EQUIPMENT_LOOKUP = gql`
    query barangayEquipmentsLookup($barangay_uid: String, $searchFilter: SearchParams) {
		barangayEquipmentsLookup(barangay_uid: $barangay_uid, searchFilter: $searchFilter)
    }
`

const Facilities = (props) => {
	const { 
		client, barangay_uid,
		onSelectedItem, onChange, ...rest 
	} = props
	const [searchText, setSearchText] = useState('')

	return (
		<Query 
			query={BARANGAY_EQUIPMENT_LOOKUP}
			variables={{
				barangay_uid,
				searchFilter: { page: 1, pageSize: 50, searchText }
			}}
			fetchPolicy='network-only'
		>
			{({ loading, error, data }) => {
				const equipments = _.has(data, 'barangayEquipmentsLookup') ? data.barangayEquipmentsLookup.data : []
				//console.log('purok', purok)
				return (
					<Select { ...rest }
						loading={loading}
						allowClear
						showSearch
						placeholder='Select Equipment'
						onSearch={(value) => setSearchText(value)}
						notFoundContent={null}
						showArrow={false}
						filterOption={false}
						onChange={(value) => {
							if (onSelectedItem) {
								const mEquipment = _.find(equipments, (i) => _.isEqual(i.uid, value))
								onSelectedItem(mEquipment)
							}
							onChange(value)
						}}
					>
						{
							equipments.map((item, key) => (
								<Option key={key} value={item.uid}>{item.name}</Option>
							))
						}
					</Select>
				)
			}}
		</Query>
	)
}

const composed = compose(
	withApollo
)

export default composed(Facilities)